



































































































import DefaultHeader from '../../../main/default-header.vue'
import HeroSearchField from '../../../shared/components/hero-search-field.vue'
import { Injector } from '@/config/dependency-injection'
import Component from 'vue-class-component'
import { ProjectLiteViewModel } from '@/business/project/interfaces/project-lite-view-model'
import RespondecoLoadingIndicator from '@/shared/components/respondeco-loading-indicator.vue'
import RespondecoPager from '@/main/respondeco-pager.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { BaseComponent } from '@/shared/components/base-component'
import { DataSourcePaginator } from '@/shared/models/data/data-source-paginator'
import { ProjectDataSource } from '@/business/project/project-data-source'
import { Paginator } from '@/shared/models/data/paginator'
import RespondecoPagination from '@/main/respondeco-pagination.vue'
import { BButton } from 'bootstrap-vue'
import RespondecoCategoryFilter from '@/main/respondeco-category-filter.vue'
import { StringMap } from '@/shared/utils/map'
import RespondecoSearchResultItem from '@/shared/components/respondeco-search-result-item.vue'
import RespondecoSearchResults from '@/shared/components/respondeco-search-results.vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import { activeUserIsAdmin } from '@/shared/utils/user'
import { isDesktop } from '@/shared/utils/is-desktop'
import RespondecoFilterToggle from '@/shared/components/respondeco-filter-toggle.vue'

@Component({
  name: 'project-page',
  components: {
    RespondecoFilterToggle,
    RespondecoToolbar,
    RespondecoSearchResults,
    RespondecoSearchResultItem,
    RespondecoCategoryFilter,
    UnifyButton,
    RespondecoPager,
    RespondecoPagination,
    RespondecoLoadingIndicator,
    HeroSearchField,
    DefaultHeader,
    BButton,
  },
})
export default class ProjectsPage extends BaseComponent {
  private paginator!: Paginator<ProjectLiteViewModel>

  private dataSource = Injector.get(ProjectDataSource)

  constructor() {
    super()

    this.paginator = new DataSourcePaginator<ProjectLiteViewModel>(this.dataSource)
  }

  get canCreateProject(): boolean {
    return activeUserIsAdmin()
  }

  get isInitializing(): boolean {
    return this.paginator.isInitializing()
  }

  get isDesktop(): boolean {
    return isDesktop()
  }

  get isSearching(): boolean {
    return this.paginator.isSearching()
  }

  get items(): ProjectLiteViewModel[] {
    return this.paginator.items
  }

  get page(): number {
    return this.paginator.page
  }

  get pageSize(): number {
    return this.paginator.pageSize
  }

  get total(): number {
    return this.paginator.total
  }

  // Lifecycle methods
  public mounted() {
    this.paginator.initialize()

    this.metaService.updateDocumentTitle('projects')
  }

  public changePage(page: number): void {
    // Update only if the page has changed
    if (this.paginator.page !== page) {
      this.paginator.changePage(page).update()
    }
  }

  public changePageSize(pageSize: number): void {
    // Update only if the page size has changed
    if (this.paginator.pageSize !== pageSize) {
      this.paginator.changePageSize(pageSize).update()
    }
  }

  public reset(): void {
    this.paginator.reset().update()
  }

  public search(term?: string): void {
    this.paginator.query(term).update()
  }

  public updateCategories(categories: StringMap<boolean>): void {
    this.paginator.categories(categories)
  }
}
